module.exports = __webpack_public_path__ + "img/59.df902e24.df902e24.svg";